import { inflect } from 'inflection';
import React from 'react';
import type { GroupBase, NoticeProps } from 'react-select';
import { components } from 'react-select';
import EmptyState from '../../components/EmptyState';
import type { OptionTypeBase } from '../../components/Select';
import type {
  CategorizedSelectCustomProps,
  EntityCategoryOption,
  EntitySelectCategorizedSearchResult,
} from './CategorizedEntitySelect';
import CategoryHeadingButton from './CategoryHeadingButton';
import * as styles from './EntitySelectNoOptionsMessage.module.scss';

type EntitySelectNoOptionsMessageProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean = boolean,
  GroupType extends GroupBase<OptionType> = GroupBase<OptionType>,
> = NoticeProps<OptionType, IsMulti, GroupType> & {
  selectProps: NoticeProps<OptionType, IsMulti, GroupType>['selectProps'] &
    Partial<CategorizedSelectCustomProps>;
};

const EntitySelectNoOptionsMessage = <IsMulti extends boolean = boolean>(
  props: EntitySelectNoOptionsMessageProps<
    EntitySelectCategorizedSearchResult,
    IsMulti,
    EntityCategoryOption
  >,
) => {
  const {
    selectProps: { selectedEntityCategory, onHeaderClick },
  } = props;
  return (
    <components.NoOptionsMessage {...props} className={styles.noOptions}>
      {selectedEntityCategory && (
        <div className={styles.wrapper}>
          <div className={styles.heading}>
            {inflect(selectedEntityCategory, 2)}
          </div>
          <CategoryHeadingButton
            selectedEntityCategory={selectedEntityCategory}
            onHeaderClick={() => onHeaderClick?.()}
          />
        </div>
      )}
      <div className={styles.empty}>
        <EmptyState
          message="No results found"
          imageName="notFound"
          smallText
          vertical
          noMargin
        />
      </div>
    </components.NoOptionsMessage>
  );
};

export default EntitySelectNoOptionsMessage;
